import type { ReactNode } from 'react';
import { SxProps, ToggleButton, ToggleButtonGroup, type ToggleButtonGroupProps } from '@mui/material';

interface ToggleButtonSelectProps<T extends string> extends Pick<
  ToggleButtonGroupProps,
  'aria-label' | 'aria-labelledby'
> {
  value: T;
  sx?: SxProps;
  options: readonly { value: T; label: ReactNode }[];
  onChange: (value: T) => void;
}

export const ToggleButtonSelect = <T extends string>({
  value,
  options,
  onChange,
  sx,
  ...props
}: ToggleButtonSelectProps<T>) => (
  <ToggleButtonGroup
    {...props}
    exclusive
    size="small"
    value={value}
    onChange={(_, next: T | null) => {
      if (next !== null) onChange(next);
    }}
  >
    {options.map(option => (
      <ToggleButton key={option.value} value={option.value} sx={{ ...sx, textTransform: 'none' }}>
        {option.label}
      </ToggleButton>
    ))}
  </ToggleButtonGroup>
);
